<template>
	<div class="round_category_wrap">
		<div
			v-for="item in props.data"
			:key="item.rise_rate_pk"
			class="category_item"
			@click="onClickCategory(item.rise_rate_pk)"
		>
			<div class="category_img_container">
				<img :src="item.image_path" alt="category_img" loading="lazy" />
			</div>
			<p class="category_name">{{ item.rise_rate_category_name }}</p>
		</div>
	</div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';

import { SectorTheme } from '@/api/topGaining';
import { CANCEL, CONFIRM_LOGIN, LOGIN_REQUIRED_PAGE } from '@/constants/title';
import { useLoginPopupStore } from '@/stores/LoginPopup';
import { useTokenStore } from '@/stores/token';

const props = defineProps<{
	data: SectorTheme[];
	sort: string;
}>();

const router = useRouter();
const loginPopupStore = useLoginPopupStore();
const tokenStore = useTokenStore();

const onClickCategory = async (riseRatePk: number) => {
	if (!tokenStore.isLogin) {
		loginPopupStore.openPopup({
			icon: 'alert',
			content: LOGIN_REQUIRED_PAGE,
			confirm: () => router.push('/auth/login'),
			confirmText: CONFIRM_LOGIN,
			cancelText: CANCEL,
		});
		return;
	}

	// TopGaining 상세로 이동
	router.push(`/topgaining/topgaining-detail/${props.sort}/${riseRatePk}`);
};
</script>

<style scoped lang="scss">
.round_category_wrap {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	@media screen and (max-width: 1280px) {
		grid-template-columns: repeat(3, 1fr);
	}
	.category_item {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		gap: 1rem;
		height: 10.8rem;
		margin: 1.6rem;
		cursor: pointer;
		.category_img_container {
			width: 5rem;
			height: 5rem;
			overflow: hidden;

			img {
				width: 100%;
				height: 100%;
				object-fit: contain;
			}
		}
		.category_name {
			font-size: var(--font-s-mid);
			font-weight: var(--font-w-semi-bold);
			line-height: normal;
			white-space: nowrap;
		}
	}
}
</style>
